import UserResource from '@/resources/UserResource';

export default class User {
    constructor() {
        this.Resource = new UserResource()
    }

    async get () {
        const user = await this.Resource.get()
        return user.data.me
    }

    getInfo () {
        return this.Resource.getInfo()
    }

    async getIntegrations (websiteId) {
        const user = await this.Resource.getIntegrations(websiteId)
        return user.data.me.websites[0]
    }

    async updatePassword (oldPassword, newPassword, repeatPassword) {
        return await this.Resource.updatePassword(oldPassword, newPassword, repeatPassword)
    }

    async getPayments () {
        const user = await this.Resource.get()
        return user.data.me.payments
    }


    async getName () {
        const user = await this.Resource.getName()
        return user.data.me.full_name
    }

    async update (user) {
        return await this.Resource.update(user)
    }

    async updateAddress (countryCode, state, company, postcode, streetName, city, vat) {
        return await this.Resource.updateAddress(countryCode, state, company, postcode, streetName, city, vat)
    }
}
